import React from 'react';
import './FieldMismatchNotice.css';

const FieldMismatchNotice = ({
    extractedValue,
    onAcceptTyped,
    onDismiss,
}) => (
    <div className="field-mismatch-notice" role="status">
        <p>
            El valor no coincide con el leído en la tarjeta
            {extractedValue ? ` (${extractedValue})` : ''}.
            Puedes usar el que escribiste si el documento se leyó mal.
        </p>
        <div className="field-mismatch-notice-actions">
            <button type="button" className="field-mismatch-notice-accept" onClick={onAcceptTyped}>
                Aceptar lo que escribí
            </button>
            <button type="button" className="field-mismatch-notice-dismiss" onClick={onDismiss}>
                No hacer nada
            </button>
        </div>
    </div>
);

export default FieldMismatchNotice;
